import {Base,Axios} from "@/api/Base"

export class ReportDownYearlyPayrollReport extends Base {

    path = "report/downYearlyPayrollReport"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}